module.exports = __webpack_public_path__ + "assets/img/meiguo.b5b35746.png";